module.exports = __webpack_public_path__ + "static/media/40.33487b65.ogg";